const initalState = {
    loading: false,
    rootAccessusers: null,
    error:null,
    updateLoading: false, 
    updateError: null,
    updateError500: null,  
    updateSuccess: null,
    deleteLoading: false,
    deleteError: null,
    deleteError500: null,
    deleteSuccess: false
  }
  
  export const user = (state = initalState, action) => {
    switch (action.type) {
      case "REQUEST_ALL_USER": {
        return { ...state, loading: true, error: null, createLoading: false, createError: null, createSuccess: null, updateSuccess: null, updateError: null, deleteSuccess: false }
      }
      case "REQUEST_ALL_USER_SUCCESS": {
        return { ...state, rootAccessusers: action.payload, error: null, loading: false, }
      }
      case "REQUEST_ALL_USER_FAILED": {
        return { ...state, loading: false, error: action.payload }
      }
      case "UPDATE_REQUEST_USERACCESS": {
        return { ...state, updateLoading: true, updateError: null, updateSuccess: null }
      }
      case "UPDATE_REQUEST_USERACCESS_SUCCESS": {
        return { ...state, updateSuccess: action.payload, updateError: null, updateLoading: false, }
      }
      case "UPDATE_REQUEST_USERACCESS_FAILED": {
        return { ...state, updateLoading: false, updateError: action.payload }
      }
      case "UPDATE_REQUEST_USERACCESS_FAILED_500": {
        return { ...state, updateLoading: false, updateError500: action.payload }
      }
      case "DELETE_REQUEST_USERACCESS": {
        return { ...state, deleteLoading: true, deleteError: null, deleteSuccess: false }
      }
      case "DELETE_REQUEST_USERACCESS_SUCCESS": {
        return { ...state, deleteSuccess: true, deleteError: null, deleteLoading: false, }
      }
      case "DELETE_REQUEST_USERACCESS_FAILED": {
        return { ...state, deleteLoading: false, deleteError: action.payload, deleteSuccess: false }
      }
      default: {
        return state
      }
    }
  }
  